<template>
  <div class="login-bd">
    <div class="login-bg">
      <div class="login-header">
        <div class="left">
          <!-- <img class="logo" src="../../images/login/logo.png" alt /> -->
          <img class="name" src="../../images/login/name.png" alt />
        </div>
        <div class="right" ref="lang">
          <select-lang @giveLanguage="getLoginConfig"></select-lang>
        </div>
      </div>
      <div class="content warpper">
        <div class="ub ub-ae">
          <!-- 密码登录 -->
          <div class="wrap-right">
            <div class="login-form-box">
              <div class="title ub">
                <div class="ub-f1">
                  <h1>{{ $t('login_login.mi_ma_deng_lu') }}</h1>
                </div>
                <div>
                  <div class="tip">{{ $t('login_login.sao_ma_deng_lu') }}</div>
                  <img class="qr" src="../../images/login/qrcode.png" alt />
                </div>
              </div>
              <div class="form-box">
                <div class="input-box">
                  <input type="text" v-model="form.loginName" :placeholder="$t('login_login.zhmcsjhyx')" />
                </div>
                <div class="input-box">
                  <input :type="passwordShow ? 'text' : 'password'" v-model="form.loginPwd" :placeholder="$t('login_login.qsrdlmm')" />
                  <i class="icon" :class="[passwordShow ? 'icon-xianshi' : 'icon-yincang']" @click="passwordShowChange"></i>
                </div>
                <!-- <div style="height: 36px" id="your-dom-id" class="nc-container"></div> -->
                <div class="btn" @click="login">
                  <span v-if="isLoading">{{ $t('login_login.deng_lu_zhong') }}</span>
                  <span v-else>{{ $t('login_login.deng_lu') }}</span>
                </div>
                <p class="forword" @click="jump('/findpassword')">
                  <span>{{ $t('login_login.wang_ji_mi_ma') }}</span>
                </p>
                <div class="other ub">
                  <div class="label">{{ $t('login_login.qtdlfs') }}</div>
                  <div class="way ub-f1">
                    <i @click="wxScanLogin(appId, 'login')" class="icon icon-wechat"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer ub ub-sp ub-xc">
      <div>
        <img v-if="showLogo" class="logo" src="../../images/login/footer.png" alt />
      </div>
      <div class="wrap">
        <p>{{ $t('login_login.dyygdkhqzychzzqjsbyy') }}</p>
        <div>
          {{ $t('login_login.Copyright2023ICEbqsy') }}
          <span>{{ $t('login_login.bei_an_hao') }}</span>
          <a href="http://beian.miit.gov.cn/" target="_blank">{{ $t('login_login.yueICPbei15022985hao') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NoCaptcha from 'noCaptcha';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import selectLang from './components/select_lang.vue';

export default {
  components: { selectLang },
  data() {
    return {
      appId: '',
      form: {
        appCode: 'isynergy',
        loginName: '',
        loginPwd: '',
        sessionId: '',
        sig: '',
        ncToken: '',
        scene: '',
      },
      formValid: {
        loginName: { required: true, message: this.$t('login_login.qtxdlzh') },
        loginPwd: { required: true, message: this.$t('login_login.qtxdlmm') },
        // sessionId: { required: true, message: '请按住滑块拖动到最右边' },
      },
      isLoading: false,
      passwordShow: false,
      // siteCode: ''
    };
  },
  computed: {
    showLogo: () => window.location.hostname !== 'eu.ice980.com'
  },
  mounted() {
    this.$store.commit('INCLUDELIST', []);
    this.$store.commit('TAGS', []);
  },
  methods: {
    // 获取登录配置
    getLoginConfig: function () {
      this.$getJSON(apis.NcConfig).then((res) => {
        this.appId = res.data.appId;
        this.form.scene = res.data.scene;
        this.formValid.loginName.message = this.$t('login_login.qtxdlzh');
        this.formValid.loginPwd.message = this.$t('login_login.qtxdlmm');
        this.formValid.sessionId.message = this.$t('login_login.qazhktddzyb');
      });
    },
    // 初始化滑块
    // initSlide: function (param) {
    //   const _this = this;
    //   this.form.ncToken = ['CF_APP_1', new Date().getTime(), Math.random()].join(':');
    //   const ncOpt = {
    //     // 声明滑动验证需要渲染的目标元素ID。
    //     renderTo: '#your-dom-id',
    //     // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
    //     appkey: param.appKey,
    //     // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
    //     scene: param.scene,
    //     // 滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
    //     token: this.form.ncToken,
    //     // 滑动条的宽度。
    //     customWidth: 280,
    //     // 业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
    //     trans: { key1: 'code0' },
    //     // 通过Dom的ID属性自动填写trans业务键，可为空。建议您按照线上问题定位文档中推荐的方法配置该字段值。
    //     elementID: ['usernameID'],
    //     // 是否自定义配置底层采集组件。如无特殊场景，请使用默认值（0），即不自定义配置底层采集组件。
    //     is_Opt: 0,
    //     // 语言。PC端Web页面场景默认支持18国语言，详细配置方法请参见自定义文案与多语言文档。
    //     language: `${param.language}`.toLowerCase(),
    //     // 是否启用。一般情况，保持默认值（true）即可。
    //     isEnabled: true,
    //     // 内部网络请求的超时时间。一般情况建议保持默认值（3000ms）。
    //     timeout: 3000,
    //     // 允许服务器超时重复次数，默认5次。超过重复次数后将触发报错。
    //     times: 5,
    //     // 用于自定义滑动验证各项请求的接口地址。一般情况，请勿配置该参数。
    //     // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
    //     callback: function (data) {
    //       _this.form.sessionId = data.csessionid;
    //       _this.form.sig = data.sig;
    //       _this.form.ncToken = data.token;
    //     },
    //   };
    //   const nc = new NoCaptcha(ncOpt);
    //   nc.upLang(`${param.language}`.toLowerCase(), {
    //     _startTEXT: "请按住滑块拖动到最右边",
    //     _yesTEXT: "验证通过",
    //     _error300: "哎呀，出错了，点击刷新再来一次",
    //     _errorNetwork: "网络不给力，请点击刷新",
    //   });
    //   // nc.reload();
    // },
    // 登录
    login: async function () {
      if (this.isLoading) {
        return;
      }
      const result = await this.$validator(this.formValid, this.form);
      if (result) {
        this.$message.error(result[0].message);
        return;
      }
      this.isLoading = true;
      this.$postJSON(apis.Login, Object.assign({}, this.form, { loginPwd: this.encrypt(this.form.loginPwd) }))
        .then((res) => {
          const timeOut = Number(moment(Date.now()).format('X')) + res.data.token.expiresIn;
          Cookies.set('token', res.data.token.accessToken, { path: '/' });
          Cookies.set('tokenTimeOut', timeOut, { path: '/' });
          Cookies.set('nonMetric', res.data.nonMetric, { path: '/' });
          this.$store.commit('USERINFO', res.data.userInfo);
          this.$store.commit('TIMEZONEID', res.data.timeZoneId);
          this.$store.commit('TIMEZONECOUNT', res.data.timeZoneCount);
          this.$store.commit('DATEFORMAT', res.data.dateFormat);
          this.$store.commit('ISTIME24H', res.data.isTime24h);
          this.$store.commit('PSWDLOGINCHANGE', res.data.pswdLoginChange);
          this.$store.commit('TIMEZONESHORT', res.data.timeZoneShort);
          this.$store.commit('FUNCVIEW', {});
          this.$store.commit('LANGUAGE', {});
          this.$store.commit('MENU_ROLE_BO_LIST', res.data.menuRoleBoList);
          this.jumpHome(() => {
            this.isLoading = false;
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // 根据当前code去获取数据

    passwordShowChange() {
      this.passwordShow = !this.passwordShow;
    },

    // 获取首页
    jumpHome(cb) {
      this.$getJSON(apis.AppList, { appType: 2 })
        .then((res) => {
          cb();
          const appList = res.data;
          if (appList && appList.length) {
            const appId = appList[0]['appId'];
            this.initAppMenu(appId);
            // this.jump('/admin/dashboard');
            return;
          }
          this.$message.error(this.$t('login_login.gzhwfpqxqlxgly'));
          this.signout();
        })
        .catch(() => {
          cb();
        });
    },
    // 应用首菜单
    initAppMenu: function (appId) {
      this.$getJSON(`${apis.App}/${appId}`).then((res) => {
        const menu = res.data || [];
        const firstMenu = menu[0] || {};
        const firstMenuItem = firstMenu.children && firstMenu.children[0] ? firstMenu.children[0] : firstMenu;
        this.jump(firstMenuItem.loadRes);
      });
    },
    // 退出登录
    signout: function () {
      this.$postJSON(apis.Logout).finally(() => {
        this.$store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('nonMetric', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../style/colors.scss';

.login-bd {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  position: relative;
  .warpper {
    width: 1280px;
    margin: 0 auto;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 681px;
    background-color: #4dd8ff;
  }
  .login-bg {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    background: url('../../images/login/bg.png') no-repeat top center;
    background-size: 100% auto;
    position: relative;
    z-index: 10;
  }
  .content {
    margin: 0 auto;
    position: relative;
  }
  .wrap-left {
    position: relative;
    height: 580px;
    img {
      margin-top: 114px;
      margin-left: 15px;
    }
    .box {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
  .wrap-right {
    padding-top: 120px;
    padding-right: 100px;

    .input-box {
      position: relative;
      .icon {
        font-size: 18px;
        color: #dee2e6;
        position: absolute;
        right: 10px;
      }
    }
  }
}
</style>
